import React from "react";
import { withSelectedField } from "./withSelectedField";
import {
  TemplateFieldV2,
  VariableLocationEdges,
} from "../../../../docuclipper/DocuclipperTypes";
import { Button, Row, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import PopoverHelp from "../../../Docuclipper/PopoverHelp";
import Creatable from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TrackedButtonWithTooltip } from "../../../Docuclipper/TrackedButton";
import {
  updateForbiddenWordsEnabled,
  updateForbiddenWords,
  deleteForbiddenWords,
  addForbiddenWords,
  fetchExtractedData,
} from "../../../../redux/reducers/TemplateField";

type Props = {
  vl: VariableLocationEdges;
  field: TemplateFieldV2;
};

const ForbiddenWords2: React.SFC<Props> = ({ vl, field }) => {
  const dispatch = useDispatch();
  return (
    <>
      <Row>
        <Form.Check
          type="checkbox"
          checked={vl.forbiddenWordsEnabled}
          onChange={(e) => {
            dispatch(
              updateForbiddenWordsEnabled({
                id: field.id,
                vlId: vl.id,
                enabled: e.target.checked,
              })
            );
            dispatch(
              fetchExtractedData({
                id: field.id,
              })
            );
          }}
          label="Use negative words"
        />

        <PopoverHelp header="" id="forbiddenWordsHelp" placement="bottom">
          Discard fields that include a list of words
        </PopoverHelp>
      </Row>
      {vl.forbiddenWordsEnabled && (
        <>
          {vl.forbiddenWords.map(({ id, words }, i) => {
            return (
              <Row className="my-1" key={i}>
                <div style={{ width: "80%" }}>
                  <Creatable
                    value={words.map((w) => ({ value: w, label: w }))}
                    isMulti={true}
                    onChange={(values) => {
                      dispatch(
                        updateForbiddenWords({
                          id: field.id,
                          vlId: vl.id,
                          forbiddenWordsId: id,
                          words: ((values as any) || []).map((v) => v.value),
                        })
                      );
                      dispatch(
                        fetchExtractedData({
                          id: field.id,
                        })
                      );
                    }}
                  />
                </div>
                <div className="ml-2">
                  <TrackedButtonWithTooltip
                    variant="secondary"
                    placement="bottom"
                    id="deleteForbiddenField"
                    renderTooltip={() => <span>Delete negative words</span>}
                    action="deleteForbiddenField"
                    size="sm"
                    onClick={(e) => {
                      dispatch(
                        deleteForbiddenWords({
                          id: field.id,
                          vlId: vl.id,
                          forbiddenWordsId: id,
                        })
                      );
                      dispatch(
                        fetchExtractedData({
                          id: field.id,
                        })
                      );
                    }}
                  >
                    <FontAwesomeIcon icon="trash" />
                  </TrackedButtonWithTooltip>
                </div>
              </Row>
            );
          })}
          <Row className="my-1">
            <Button
              className="ml-1"
              variant="link"
              onClick={(e) => {
                dispatch(
                  addForbiddenWords({
                    id: field.id,
                    vlId: vl.id,
                  })
                );
                dispatch(
                  fetchExtractedData({
                    id: field.id,
                  })
                );
              }}
            >
              <FontAwesomeIcon icon="plus" />
              <span className="ml-1">Add negative words</span>
            </Button>
          </Row>
        </>
      )}
    </>
  );
};

export const ForbiddenWords = withSelectedField(ForbiddenWords2);
